import React from 'react'
import { Route, Routes } from 'react-router-dom';

import AllSocial from '../socialMedia/AllSocial';

const SocialRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/all-social" element={<AllSocial />} />
            </Routes>
        </>
    )
}

export default SocialRoutes;